<script setup>
import { computed } from 'vue';
import ChannelSelector from '../ChannelSelector.vue';
import {
  isBetaChannel,
  isChannelActive,
} from 'dashboard/helper/channelAvailability';

const props = defineProps({
  channel: {
    type: Object,
    required: true,
  },
  enabledFeatures: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['channelItemClick']);

const isActive = computed(() =>
  isChannelActive(props.channel.key, props.enabledFeatures)
);

const isBeta = computed(() => isBetaChannel(props.channel.key));

const hasVoiceBadge = computed(() => {
  return (
    ['voice', 'whatsapp_call'].includes(props.channel.key) &&
    (props.enabledFeatures.channel_voice ||
      props.enabledFeatures.channel_whatsapp_call)
  );
});

const onItemClick = () => {
  if (isActive.value) {
    emit('channelItemClick', props.channel.key);
  }
};
</script>

<template>
  <ChannelSelector
    :title="channel.title"
    :description="channel.description"
    :icon="channel.icon"
    :is-beta="isBeta"
    :has-voice-badge="hasVoiceBadge"
    :disabled="!isActive"
    @click="onItemClick"
  />
</template>
